import { css } from '@bts-web/utils-style-engine';
import { PropsWithChildren, ReactElement } from 'react';
import { ErrorRetryButton } from '../../../layouts/ErrorBoundary/ErrorRetryButton';
import { GoToPortfolioButton } from '../buttons/GoToPortfolioButton/GoToPortfolioButton';
import { RegularExclamationTriangle } from '../../svgIcons';

interface ErrorMessageProps extends PropsWithChildren {
  title: string | ReactElement;
  description?: string | ReactElement;
  withRetryButton?: boolean;
  withPortfolioButton?: boolean;
  retryButtonCallback?: () => void;
}

export const ErrorMessage = ({
  title,
  description,
  withRetryButton,
  withPortfolioButton,
  retryButtonCallback,
}: ErrorMessageProps) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'medium',
      py: 'medium',
      width: '100%',
      maxWidth: 400,
    })}
  >
    <div
      className={css({
        width: 80,
        height: 80,
        mx: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'neutrals.fill_quinary',
        borderRadius: 'largeBottomLeft',
      })}
    >
      <RegularExclamationTriangle size={24} />
    </div>

    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        p: 'small',
        gap: 'extra_small_2',
        textAlign: 'center',
        margin: 'auto',
        mt: 0,
      })}
    >
      <p
        className={css({
          color: 'neutrals.text_primary',
          fontSize: 'headline.small_medium',
          fontWeight: 'headline.small_medium',
          lineHeight: 'headline.small_medium',
        })}
      >
        {title}
      </p>

      {description && (
        <p
          className={css({
            color: 'neutrals.text_secondary',
            fontSize: 'body.medium',
            fontWeight: 'body.medium',
            lineHeight: 'body.medium',
          })}
        >
          {description}
        </p>
      )}
    </div>

    {withRetryButton && (
      <ErrorRetryButton
        {...(retryButtonCallback && { onClick: retryButtonCallback })}
      />
    )}

    {withPortfolioButton && <GoToPortfolioButton />}
  </div>
);
